const logError = (error, info) => {
  // Do something with the error, e.g. log to an external API
  console.log("Error -> " + error);
  console.log("Info -> " + JSON.stringify(info.componentStack));
};

export default logError;
